import { errorBody } from "./battery-financing-errors"
import { responseErrorCode } from "./pricing-errors"

/** Compute: the chosen node isn't offered (or catalogued) for the proposal now. */
export const BATTERY_COMPUTE_INVALID_CODE = `BATTERY_COMPUTE_INVALID`
/** Compute: the equipment or Finance Plan changed while the options loaded. */
export const BATTERY_COMPUTE_SUPERSEDED_CODE = `BATTERY_COMPUTE_SUPERSEDED`
/** Compute: no battery equipment is saved, so PowurOS can't be asked. */
export const BATTERY_COMPUTE_EQUIPMENT_REQUIRED_CODE = `BATTERY_COMPUTE_EQUIPMENT_REQUIRED`

/** The `code` a Battery compute command answered with, when it is one. */
export const batteryComputeErrorCode = (error: unknown): string | null => {
  const body = errorBody(error)
  const code = body?.code ?? responseErrorCode(error)
  return typeof code === `string` ? code : null
}

/**
 * The reasons a Battery compute command gave: the gateway lists several in
 * `message` (validation and constraint failures), or gives one.
 */
export const batteryComputeErrorMessages = (error: unknown): string[] => {
  const message = errorBody(error)?.message
  if (Array.isArray(message)) {
    return message.filter(
      (entry): entry is string => typeof entry === `string` && entry !== ``,
    )
  }
  return typeof message === `string` && message !== `` ? [message] : []
}
